// @flow
const LAUNCHPAD_SNAPSHOT = {
  payments: {
    card: {
      number_input_max_length: 23,
      cc_number_max_length: 19,
      cvv_number_min_length: 3,
      cvv_number_max_length: 4,
      minimal_card_number_length: 12,
      default_card_mask: "9999 9999 9999 9999",
      card_types: {
        visa: {
          enabled: true,
          name: "Visa",
          length: [13, 16],
        },
        mastercard: {
          enabled: true,
          name: "Mastercard",
          length: [16],
        },
        maestro: {
          enabled: true,
          name: "Maestro",
          length: [12, 13, 14, 15, 16, 17, 18, 19],
        },
        amex: {
          enabled: true,
          name: "Amex",
          length: [15],
          cvv_length: 4,
          mask: "9999 999999 99999",
          specified_currencies_only: [
            "aud",
            "cad",
            "czk",
            "dkk",
            "eur",
            "gbp",
            "hkd",
            "huf",
            "chf",
            "jpy",
            "krw",
            "nok",
            "nzd",
            "pln",
            "sek",
            "sgd",
            "usd",
            "zar",
          ],
        },
        jcb: {
          enabled: true,
          name: "JCB",
          length: [16],
          specified_currencies_only: [
            "aed",
            "aud",
            "cny",
            "czk",
            "hkd",
            "huf",
            "chf",
            "idr",
            "inr",
            "jpy",
            "krw",
            "myr",
            "php",
            "pln",
            "ron",
            "thb",
            "try",
            "twd",
          ],
        },
        dinersclub: {
          enabled: true,
          name: "Diners Club",
          length: [14],
          specified_currencies_only: ["eur"],
        },
        mir: {
          enabled: true,
          name: "Мир",
          length: [16],
          specified_currencies_only: ["rub"],
        },
        unionpay: {
          enabled: true,
          name: "China Unionpay",
          length: [16, 17, 18, 19],
        },
        discover: {
          enabled: false,
          name: "Discover",
          length: [16],
          specified_currencies_only: ["eur"],
        },
      },
      pos_enabled_currencies: [
        "aed",
        "amd",
        "aud",
        "bhd",
        "byn",
        "cad",
        "clp",
        "cny",
        "czk",
        "dkk",
        "eur",
        "gbp",
        "hkd",
        "huf",
        "chf",
        "idr",
        "ils",
        "inr",
        "isk",
        "jod",
        "jpy",
        "kgs",
        "krw",
        "kwd",
        "kzt",
        "mxn",
        "myr",
        "nok",
        "nzd",
        "omr",
        "pen",
        "php",
        "pln",
        "qar",
        "ron",
        "rsd",
        "rub",
        "sar",
        "sek",
        "sgd",
        "thb",
        "try",
        "twd",
        "uah",
        "usd",
        "uzs",
        "yer",
        "zar",
      ],
      extended_form_currencies: ["rub", "mxn", "try"],
    },
    paypal: {
      countries: ["de", "fr", "at"],
      currencies: ["eur"],
    },
    sofort: {
      countries: ["de", "nl", "fr", "pl", "es", "hu", "sk"],
      currencies: ["eur"],
    },
    trustly: {
      countries: ["sv", "da", "fi", "pl", "nl", "es", "ee"],
      currencies: ["eur", "sek", "dkk", "nok"],
    },
    alipay: {
      countries: ["cn"],
      currencies: ["cny"],
    },
  },
}

export default LAUNCHPAD_SNAPSHOT
